import { Pipe, PipeTransform} from '@angular/core';
@Pipe({
    name : 'CustFilter'
})

export class CustFilter implements PipeTransform{
    transform(customers: any[], searchTerm : any): any{
        if (customers==null || customers==undefined){
            return null;
        }
        return customers.filter(customer=>{
            return (customer.cust_code.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1) ||
                   (customer.cust_name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1);

        });
    }
}



// WEBPACK FOOTER //
// ./src/filters/custFilter.pipe.ts